'use client';

import { useEffect, useRef } from 'react';

interface ProductShowcaseVideoProps {
  src: string;
  playbackRate: number;
  className?: string;
  trigger: string;
}

export function ProductShowcaseVideo({
  src,
  playbackRate,
  className,
  trigger,
}: ProductShowcaseVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.playbackRate = playbackRate;
    void video.play().catch(() => {
      // Muted autoplay can still be interrupted by browser policy; the
      // rendered fallback remains the loaded video frame.
    });
  }, [playbackRate]);

  return (
    <video
      ref={videoRef}
      className={className}
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      data-trigger={trigger}
      data-playback-rate={playbackRate}
    >
      <source src={src} type="video/mp4" />
    </video>
  );
}
